var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "copy",
    d: "M13.594-13.125H4.219a1.406,1.406,0,0,0-1.406,1.406v1.406H1.406A1.406,1.406,0,0,0,0-8.906V.469A1.406,1.406,0,0,0,1.406,1.875h9.375A1.406,1.406,0,0,0,12.187.469V-.937h1.406A1.406,1.406,0,0,0,15-2.344v-9.375A1.406,1.406,0,0,0,13.594-13.125ZM10.605.469H1.582A.176.176,0,0,1,1.406.293V-8.73a.176.176,0,0,1,.176-.176h1.23v6.562A1.406,1.406,0,0,0,4.219-.937h6.562V.293A.176.176,0,0,1,10.605.469Zm2.812-2.812H4.395a.176.176,0,0,1-.176-.176v-9.023a.176.176,0,0,1,.176-.176h9.023a.176.176,0,0,1,.176.176V-2.52A.176.176,0,0,1,13.418-2.344Z",
    transform: "translate(0 13.125)",
    fill: "#666"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.6b86311e.svg";
export { ForwardRef as ReactComponent };